export default "__VITE_ASSET__D3Jsis$f__"